import { environment } from "src/environments/environment";

export function checkDomain() {
  const host = window.location.host;
  const parts = host.split('.');
  const domainLength = 2;
  // domain checking
  if (parts.length === domainLength - 1) {
    return 'root';
  } else if (parts[0]) {
    return parts[0];
  }
  return false;
}

// export function checkDomain() {
//   // Get the host from the current URL
//   let host = window.location.host;  
//   console.log('host', host);
  
//   // Remove 'www.' if it exists
//   if (host.startsWith('www.')) {
//     host = host.slice(4);
//   }

//   if (host.includes(':')) {
//     host = host.split(':')[0];
//   }

//   const parts = host.split('.');
//   const envParts = environment.APP_URL.split('.');
  
//   if (host === environment.APP_URL) {
//     return environment.ROUTING_NAME;
//     // return host2;
//     } else if (host !== environment.APP_URL) {
//     if (parts.length - envParts.length == 1) {
//       // If the lengths are the same, return the first part of the host
//       return parts[0];
//     } else {
//       // If the lengths differ, return the difference by slicing
//       const difference = parts.slice(0, parts.length - envParts.length);
//       let api = difference.join('.')
//       return api; // Join the subdomain parts back into a string
//     }
//   }
  
//   return false;
// }
